export enum ToastrType {
  Success = 'success',
  Error = 'error',
  Warning = 'warning',
  Info = 'info',
  Primary = 'primary',
}
